export default function SiteFooter() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col lg:flex-row justify-between gap-10">
          {/* 品牌与说明 */}
          <div className="max-w-sm">
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-950">
                <i className="ri-archive-stack-line text-xl" />
              </span>
              <div className="leading-none">
                <p className="font-heading text-lg font-bold text-background-50">全网黑料</p>
                <p className="mt-1 text-[11px] tracking-[0.2em] text-background-400">
                  旧料考古档案
                </p>
              </div>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-background-400">
              聚焦全网黑料旧料、历史遗留与早年黑历史的考古式整理。以考据代替情绪，让被删掉与忘掉的内容有据可查。
            </p>
          </div>

          {/* 栏目 */}
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-8 text-sm">
            <div>
              <p className="font-semibold text-background-100">内容分区</p>
              <ul className="mt-4 flex flex-col gap-3">
                <li><a href="#focus" className="text-background-400 hover:text-accent-300">焦点旧料</a></li>
                <li><a href="#zones" className="text-background-400 hover:text-accent-300">分类考古</a></li>
                <li><a href="#timeline" className="text-background-400 hover:text-accent-300">年代编年</a></li>
              </ul>
            </div>
            <div>
              <p className="font-semibold text-background-100">深度档案</p>
              <ul className="mt-4 flex flex-col gap-3">
                <li><a href="#deep" className="text-background-400 hover:text-accent-300">专题盘点</a></li>
                <li><a href="#hot" className="text-background-400 hover:text-accent-300">翻旧账热榜</a></li>
                <li><a href="#faq" className="text-background-400 hover:text-accent-300">阅读须知</a></li>
              </ul>
            </div>
            <div>
              <p className="font-semibold text-background-100">本页索引</p>
              <ul className="mt-4 flex flex-col gap-3">
                <li><a href="#cta" className="text-background-400 hover:text-accent-300">报料线索</a></li>
                <li><a href="#top" className="text-background-400 hover:text-accent-300">回到顶部</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 border-t border-background-800 pt-6">
          <p className="text-xs leading-relaxed text-background-500">
            免责声明：本站内容为对公开网络旧料、历史遗留与早年发言的整理与考据观察，仅供参考与讨论，不代表对任何人的最终定性。
            对未经核实或存在争议的条目，我们均明确标注「待核」，不鼓励断章取义与人身攻击。若您认为某条目涉及不实信息，可按须知提交更正说明。
          </p>
          <p className="mt-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 text-xs text-background-500">
            <span>© 2026 全网黑料网 · 旧料考古档案</span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-database-2-line" />
              单页静态展示 · 不接账号 / 评论 / 登录
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}